export default "__VITE_ASSET__b42e1a43__"